import { createModelSegment } from 'client/data/luckdragon/segment';

export const RequestModel = createModelSegment('request', []);
